import { Box, Container, Typography, useTheme } from "@mui/material";
import React from "react";
import { appImages } from "../../assets";
import AppFooter from "../../components/footer";
import Header from "../../components/header";
import ApplicationForm from "./ApplicationForm";

const ApplicationRequest = () => {
  const { palette } = useTheme();

  return (
    <>
      <Box
        height={{ xs: "60vh", sm: "100vh" }}
        display="flex"
        flexDirection="column"
        position={"relative"}
        sx={{
          background: palette.gradient.background,
          backgroundImage: `url(${appImages.educationCityDetailBg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Header />

        {/* wave image */}
        <img
          src={appImages.helpPageWaveImg}
          width={"100%"}
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            left: 0,
            zIndex: 1,
          }}
        />
      </Box>

      <Box position={"absolute"} top={{ xs: 130, sm: 150 }} left={0} right={0}>
        <Container
          sx={{
            maxWidth: "1100px !important",
            position: "relative",
            zIndex: 999,
            flexGrow: 1, // Allows content to grow and push footer down
          }}
        >
          <Typography
            variant="heading_pr"
            component={"h1"}
            maxWidth={700}
            margin={"auto"}
            textAlign={"center"}
            color={"text.white"}
            lineHeight={"normal"}
            mb={5}
          >
            Shape your child's future today—enroll now for a brighter tomorrow!
          </Typography>

          <ApplicationForm/>
       
        </Container>
        <AppFooter />
      </Box>
    </>
  );
};

export default ApplicationRequest;
